import { Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { FunctionalHelpEntity } from '../functional-help.entity';

export const STATE_NAME = 'functionalHelpEntity';

// Create the NGXS state
export const FunctionalHelpEntityState: GenericEntityStateClass<FunctionalHelpEntity> =
  createEntityState<FunctionalHelpEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class FunctionalHelpEntityService extends EntityService<FunctionalHelpEntity> {
  constructor() {
    super();
    this.resourceType = 'functionalhelps';
    this.stateClass = FunctionalHelpEntityState;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): FunctionalHelpEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
